import { render, staticRenderFns } from "./scheduleIndex.vue?vue&type=template&id=23f21040"
import script from "./scheduleIndex.vue?vue&type=script&lang=js"
export * from "./scheduleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports